'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { ScrollUpButton } from './ScrollUpButton';
import { type SectionNavItem, StickyNavbar } from './StickyNavbar';
type ScrollSpyControlsProps = {
  sections: SectionNavItem[];
};
const ACTIVE_SECTION_OFFSET_PX = 300;
export function ScrollSpyControls(t0) {
  const $ = _c(11);
  const {
    sections
  } = t0;
  const [activeSection, setActiveSection] = useState(0);
  const [isHidden, setIsHidden] = useState(true);
  const stickyNavbarRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== sections) {
    t1 = () => {
      const sectionElements = sections.map(_temp).filter(_temp2);
      const showArrowUpButton = () => {
        if (!stickyNavbarRef.current) {
          return;
        }
        const offset = stickyNavbarRef.current.getBoundingClientRect().bottom + window.scrollY - ACTIVE_SECTION_OFFSET_PX;
        setIsHidden(window.scrollY <= offset);
      };
      const getActiveSection = () => {
        if (!stickyNavbarRef.current) {
          return 0;
        }
        const container = sectionElements.at(-1)?.parentElement;
        if (container) {
          const containerRect = container.getBoundingClientRect();
          const navbarRect = stickyNavbarRef.current.getBoundingClientRect();
          if (navbarRect.bottom >= containerRect.bottom) {
            return sections.at(-1)?.id ?? 0;
          }
        }
        let min = Number.MAX_SAFE_INTEGER;
        let current = 0;
        for (const [idx, element_0] of sectionElements.entries()) {
          const {
            top,
            bottom
          } = element_0.getBoundingClientRect();
          if (top < min && bottom > ACTIVE_SECTION_OFFSET_PX) {
            min = top;
            current = sections[idx]?.id ?? 0;
          }
        }
        return current;
      };
      const handleScroll = () => {
        showArrowUpButton();
        setActiveSection(getActiveSection());
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t2 = [sections];
    $[0] = sections;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isHidden) {
    t3 = !isHidden && <ScrollUpButton targetRef={stickyNavbarRef} />;
    $[3] = isHidden;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeSection || $[6] !== sections) {
    t4 = <div className="self-start lg:sticky lg:top-10" ref={stickyNavbarRef}><StickyNavbar sections={sections} activeSectionId={activeSection} /></div>;
    $[5] = activeSection;
    $[6] = sections;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(element) {
  return element !== null;
}
function _temp(t0) {
  const {
    id
  } = t0;
  return document.getElementById(`${id}`);
}